import { createContext } from 'react';

export type DataContent = {
  gasConsumption: number;
  gasPrice: number;
  gasGridManagementCost: number;
  gasFixedCost: number;
  cvInstallationCost: number;
  cvMaintenanceCost: number;
  updateGasConsumption: (gasConsumption: number) => void;
  updateGasPrice: (gasPrice: number) => void;
  updateGasGridManagementCost: (gasGridManagementCost: number) => void;
  updateGasFixedCost: (gasFixedCost: number) => void;
  updateCvInstallationCost: (cvInstallationCost: number) => void;
  updateCvMaintenanceCost: (cvMaintenanceCost: number) => void;
};

const DataContext = createContext<DataContent>({
  gasConsumption: 0,
  updateGasConsumption: () => {},
  gasPrice: 0,
  updateGasPrice: () => {},
  gasGridManagementCost: 0,
  updateGasGridManagementCost: () => {},
  gasFixedCost: 0,
  updateGasFixedCost: () => {},
  cvInstallationCost: 0,
  updateCvInstallationCost: () => {},
  cvMaintenanceCost: 0,
  updateCvMaintenanceCost: () => {},
});

export default DataContext;
